import { useContext } from "react";

import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import store from "@beeldit/core/services/store";
import { CreateActionContext } from "./CreateActionContext";

function useStore(modelConfig: any) {
  const { element, setBackendFormErrors, setLoading } =
    useContext(CreateActionContext);
  const errorHandler = useErrorHandler();
  return (onSuccess: any) => {
    setLoading(true);
    // Sanear campos de cancelación según status
    const payload = { ...element };
    if (payload.status !== 2) {
      payload.cancellation_reason = null;
      payload.cancelled_at = null;
    } else {
      // Si existe cancelled_at, intentar normalizar a ISO
      if (payload.cancelled_at) {
        try {
          payload.cancelled_at = new Date(payload.cancelled_at).toISOString();
        } catch (e) {
          // leave as is
        }
      }
    }
    store(modelConfig.endpoint, payload)
      .then((response: any) => {
        onSuccess(response.data);
      })
      .catch((error: any) => {
        console.error("Error fetching data:", error);
        errorHandler(error, setBackendFormErrors);
      })
      .finally(() => {
        setLoading(false);
      });
  };
}

export default useStore;
